import React from 'react';
import { ChecklistProgram } from "../program/ChecklistProgram";

interface LmsPackageContent {
    contents: string[];
}

interface LmsPackageProps {
    packageName: string;
    textColors?: string;
    packageContents: LmsPackageContent[]
    packageIndex?: number;
}

const LmsPackage: React.FC<LmsPackageProps> = ({ packageName, textColors, packageContents, packageIndex = 0 }) => {
    const getOutlineColor = () => {
        switch (packageIndex) {
            case 0: return 'md:hover:outline-[10px] hover:outline-[5px] hover:outline-blue-300';
            case 1: return 'md:hover:outline-[10px] hover:outline-[5px] hover:outline-green-300';
            case 2: return 'md:hover:outline-[10px] hover:outline-[5px] hover:outline-purple-300';
            default: return 'md:hover:outline-[10px] hover:outline-[5px] hover:outline-gray-300';
        }
    };

    return (
        <div className={`group badge-lms flex flex-col justify-between py-4 h-full  transition-all duration-300 bg-white hover:bg-white outline outline-1 outline-transparent ${getOutlineColor()}`}>
            <div className='flex flex-col items-center min-h-[80px]'>
                <p className={`text-xl sm:text-xl font-semibold tracking-wider bg-clip-text items-center justify-center ${textColors} group-hover:text-black`}>
                    {packageName}
                </p>
                <div className='h-px w-10 bg-secondary-100 my-2 group-hover:bg-black' />
            </div>
            <div className='mb-2 flex-grow'>
                <div>
                    {packageContents.map((content, contentIndex) => (
                        <div key={contentIndex}>
                            {content.contents.map((message, messageIndex) => (
                                <div key={messageIndex} className={`${textColors}`}>
                                    <ChecklistProgram key={`${contentIndex}-${messageIndex}`} name={message} className={`${textColors} group-hover:text-black`} />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
            <div className='mt-auto flex justify-center'>
                <a
                    href="https://wa.me/6281215636018"
                    target="_blank"
                    className="text-sm sm:text-base bg-teal-500 group-hover:bg-slate-800 text-white font-body font-semibold py-2 px-6 sm:px-12 sm:py-3 rounded transition-all duration-300">
                    Pilih Paket
                </a>
            </div>
        </div>
    );
}

export default LmsPackage;